import { createFileRoute } from "@tanstack/react-router";

// `branch` — mở thẳng két của một cơ sở: tin "két chờ bạn ký" và bảng sức khoẻ
// két dẫn tới đây kèm cơ sở, vì người ký thường phụ trách nhiều cơ sở.
type CashDrawerSearch = { branch?: string | undefined };

export const Route = createFileRoute("/_app/cash-drawer/")({
  validateSearch: (search: Record<string, unknown>): CashDrawerSearch => ({
    branch: typeof search.branch === "string" && search.branch.trim() ? search.branch.trim() : undefined,
  }),
});
